if (!window.__globalParams) {
    window.__globalParams = {};
}
export let customGlobal = {
    set(key, value) {
        window.__globalParams[key] = value;
        this.eventTarget.dispatchEvent(new CustomEvent('propertychange', {
            detail: {
                key,
                value
            }
        }))
    },
    get(key) {
        return window.__globalParams[key];
    },
    eventTarget: new EventTarget()
    // addEventListener: window.__globalParamsEventTarget.addEventListener,
    // removeEventListener: window.__globalParamsEventTarget.removeEventListener,
}

export let constKeys = {
    MARKER_LAYER_ID: "custom_marker_layer",
    NO_PERMISSION: "",
    USER_CONFIG: "user.config",
    USER_CONFIG_MENU: "user.config.menu",
    USER_CONFIG_MAINPAGE: "user.config.mainpage",
    USER_CONFIG_THEME: "user.config.theme",
    SOCKET_STATUS: "socket_status",
    TASK_STATUS: {
        STARTED: 'started',
        GOING: 'going',
        ENDED: 'ended',
        STOPPED: 'stopped',
        PROGRESS: 'progress',
        ALERT: 'alert',
        COMPLETED: 'completed',
        TERMINATED: 'terminated:'
    },
    CATALOG_TEMPLATE: {
        TABLE: 'datumburg.table',
        ARCGIS_SERVICE: 'arcgis.service',
        MAP: 'datumburg.map',
        SCRIPT_SERVICE: 'datumburg.script'
    }
}